
    
        <div class="joinus-outer">
            <div class="join-heading">
                <h3>Join Us</h3>
                <h5>Experience a customized sign-up process with Trucklots to ensure maximize ROI for your
                    parking lot.</h5>
        
            </div>
            <div class="contact-outer">
                <h4>Contact Trucklots</h4>
                <p>Our friendly team is here to help</p>
                <p><a href="mailto:support@trucklots.com"
                        style=" color: white; text-decoration: none;"><strong>support@trucklots.com</strong></a></p>
            </div>
            <div class="contact-outer last-child">
                <h4>Corporate Headquarters</h4>
                <p>40 Rahling Circle, Little Rock, AR 72223</p>
            </div>
            <div class="contact-outer ">
                <h4>Follow Us</h4>
                <ul class="social-icon">
                    <li><a href="https://www.linkedin.com/company/trucklots" target="_blank" rel="noopener"><img
                                src="../../../../../assets/images/linkdin.svg" alt="LinkedIn" /></a></li>
                    <li> <a href="https://www.facebook.com/profile.php?id=61555337986717" target="_blank" rel="noopener"><img
                                src="../../../../../assets/images/ld-fb.svg" alt="FB"/></a></li>
                </ul>
            </div>
        
        </div>
